/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

var isPlainObject = require('is-plain-object');

module.exports = function isExtendable(val) {
  return isPlainObject(val) || typeof val === 'function' || Array.isArray(val);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hover-observer/~/is-extendable/index.js
 ** module id = 1093
 ** module chunks = 0
 **/